/** @jsx jsx */
import { memo, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import { Box } from '@rebass/grid/emotion';

import Img from './Img';

const captionCss = css`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  letter-spacing: 0.52em;
  opacity: 0;
  transform: scale(0.1);
  transition: transform 0.35s, opacity 0.35s;
  font-size: 1.2em;
  h4 {
    margin: 0 0 10px;
  }

  h5 {
    font-weight: normal;
    margin: 0;
  }
`;

const thumbCss = css`
  position: relative;
  cursor: pointer;
  background-color: #000;
  &:before {
    content: '';
    display: block;
    padding-top: 56.25%;
  }

  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
  }

  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
    transition: transform 0.35s, opacity 0.35s;
  }

  @media (hover: hover) {
    &:hover {
      .css-${captionCss.name} {
        opacity: 1;
        transform: scale(1);
      }
      img {
        transform: scale(3);
        opacity: 0;
      }
    }
  }
`;

const Thumb = memo(({ client, category, video, onClick }) => {
  const thumbRef = useRef(null);
  const onThumbClick = () => {
    const {
      offsetTop: top,
      offsetLeft: left,
      offsetWidth: width,
      offsetHeight: height,
    } = thumbRef.current;

    onClick({
      url: video.url,
      box: { top, left, height, width },
    });
  };

  return (
    <Box
      ref={thumbRef}
      css={thumbCss}
      width={[1, 1 / 2, 1 / 3]}
      onClick={onThumbClick}
    >
      <div>
        <Img src={video.thumbnailUrl} alt={client} />
        <div css={captionCss}>
          <h4>{client}</h4>
          <h5>{category}</h5>
        </div>
      </div>
    </Box>
  );
});

export default Thumb;
